import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initMetaPixel } from "./utils/metaPixel";
import { initClarity } from "./utils/clarity";
import { initHeadMeta } from "./utils/headMeta";
import { captureTrackingParams } from "./utils/checkoutUrl";

// Resource hints (incl. the LCP image preload) must be in <head> before paint.
initHeadMeta();

// Store Meta Ads attribution (UTMs + fbclid) for the session on arrival.
captureTrackingParams();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-297" data-mp="2k05odb5z0v2k" />);
}

// Load analytics right after the first paint so they never compete with the
// LCP image. Meta Pixel keeps all of its events (PageView, ViewContent,
// InitiateCheckout); Microsoft Clarity runs independently alongside it.
const startTracking = () => {
  initMetaPixel();
  initClarity();
};
if (typeof window !== "undefined") {
  if ("requestIdleCallback" in window) {
    (window as Window & {
      requestIdleCallback: (cb: () => void, opts?: {
        timeout: number;
      }) => number;
    }).requestIdleCallback(startTracking, {
      timeout: 2500
    });
  } else {
    window.setTimeout(startTracking, 1200);
  }
}